import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Promise from "@babel/runtime-corejs2/core-js/promise";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = _Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import axios from 'axios';
import createRef from '@roo/create-react-ref/createRef';
import locale from '../locale';
import { clone } from '@utiljs/clone';
import omit from 'lodash/omit';
import warning from 'warning';
import { isFunction } from '@utiljs/is';

var ImageUpload = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageUpload, _React$Component);

  var _super = _createSuper(ImageUpload);

  function ImageUpload() {
    var _this;

    _classCallCheck(this, ImageUpload);

    _this = _super.apply(this, arguments);
    _this.state = {
      imgData: _this.props.imgData || '',
      maxSize: _this.props.maxSize && _this.props.maxSize * 1024 * 1000 || 0,
      file: {},
      fileList: [],
      prevProps: {}
    };
    _this.imageupload = createRef();

    _this.handleChange = function (event) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var current, files, validateRes, validityFailCallback;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.persist();
                current = this.imageupload.current;

                if (!(current && current.files && current.files[0])) {
                  _context.next = 13;
                  break;
                }

                files = current.files[0];
                _context.next = 6;
                return this.handleValidate(files);

              case 6:
                validateRes = _context.sent;

                if (validateRes) {
                  _context.next = 12;
                  break;
                }

                this.clearTargetVal(event);
                validityFailCallback = this.props.validityFailCallback;

                if (validityFailCallback) {
                  // @ts-ignore
                  validityFailCallback({
                    name: files.name,
                    size: files.size,
                    type: files.type
                  });
                }

                return _context.abrupt("return", false);

              case 12:
                // preview
                this.previewFile(files, function (result) {
                  _this2.preHandleUpload(files, result);
                });

              case 13:
                this.clearTargetVal(event);
                return _context.abrupt("return", true);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    _this.clearTargetVal = function (event) {
      event.target.value = '';
    };

    _this.clearFileVal = function () {
      var current = _this.imageupload.current;

      if (current) {
        current.value = '';
      }
    };

    _this.handleRemove = function () {
      var onRemove = _this.props.onRemove;
      var _this$state = _this.state,
          file = _this$state.file,
          imgData = _this$state.imgData;

      if (onRemove) {
        //@ts-ignore
        onRemove(clone({
          name: file.name,
          size: file.size,
          type: file.type,
          data: imgData
        }));
      }

      _this.clearFileVal();

      _this.setState({
        imgData: ''
      });
    };

    _this.handleBeforeUpload = function () {
      var beforeUpload = _this.props.beforeUpload;
      var _this$state2 = _this.state,
          file = _this$state2.file,
          imgData = _this$state2.imgData,
          fileList = _this$state2.fileList;

      if (beforeUpload) {
        return beforeUpload(clone({
          name: file.name,
          size: file.size,
          type: file.type,
          data: imgData
        }), clone(fileList));
      }

      return undefined;
    };

    _this.preHandleUpload = function (files, result) {
      _this.setState({
        imgData: result,
        file: files,
        fileList: [files]
      }, function () {
        var onChange = _this.props.onChange;
        var _this$state3 = _this.state,
            file = _this$state3.file,
            imgData = _this$state3.imgData,
            fileList = _this$state3.fileList; // onChange hook

        if (onChange) {
          onChange(clone({
            name: file.name,
            size: file.size,
            type: file.type,
            data: imgData
          }), clone(fileList));
        } // beforeUpload hook


        var beforeUpload = _this.handleBeforeUpload();

        if (beforeUpload && beforeUpload.then) {
          beforeUpload.then(function () {
            _this.handleAutoUpload();
          }).catch(function (e) {
            console.log(e);
          });
        } else if (beforeUpload !== false) {
          _this.handleAutoUpload();
        }
      });
    };

    _this.handleAutoUpload = function () {
      var _this$props = _this.props,
          autoUpload = _this$props.autoUpload,
          onSucess = _this$props.onSucess,
          onSuccess = _this$props.onSuccess,
          onFail = _this$props.onFail;

      if (autoUpload) {
        _this.handleUpload().then(function (resp) {
          if (onSucess) {
            warning(false, 'onSucess 将被舍弃，请使用 onSuccess');
            onSucess(resp);
          }

          if (onSuccess) {
            onSuccess(resp);
          }
        }).catch(function (err) {
          if (onFail) {
            onFail(err);
          }
        });
      }
    };

    _this.handleUpload = function () {
      var _this$props2 = _this.props,
          action = _this$props2.action,
          uploadParams = _this$props2.uploadParams,
          name = _this$props2.name,
          withCredentials = _this$props2.withCredentials,
          dataFormat = _this$props2.dataFormat;
      var _this$state4 = _this.state,
          imgData = _this$state4.imgData,
          file = _this$state4.file;
      var data;

      if ((dataFormat || 'FileData').toLocaleLowerCase() === 'FileData'.toLocaleLowerCase()) {
        var formData = new FormData();
        formData.append(name || 'file', file);

        if (uploadParams && _Object$keys(uploadParams) && _Object$keys(uploadParams).length) {
          for (var key in uploadParams) {
            if (uploadParams.hasOwnProperty(key)) {
              formData.append(key, uploadParams[key]);
            }
          }
        }

        data = formData;
      } else {
        data = _Object$assign(_defineProperty({}, name, imgData), uploadParams);
      }

      return new _Promise(function (resolve, reject) {
        axios({
          method: 'post',
          url: action,
          data: data,
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: withCredentials
        }).then(function (resp) {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(new Error('upload error'));
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    };

    _this.handleValidate = function (file) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var customValidate, validateRes, maxSize;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                customValidate = this.props.customValidate;

                if (!isFunction(customValidate)) {
                  _context2.next = 8;
                  break;
                }

                validateRes = customValidate(file);

                if (!(_typeof(validateRes) === 'object' && validateRes.then)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", validateRes.then(function (res) {
                  return res;
                }).catch(function () {
                  return false;
                }));

              case 5:
                return _context2.abrupt("return", validateRes);

              case 8:
                maxSize = this.state.maxSize;
                return _context2.abrupt("return", file.size <= maxSize);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    _this.previewFile = function (file, callback) {
      var reader = new FileReader();

      reader.onloadend = function () {
        return callback(reader.result);
      };

      reader.readAsDataURL(file);
    };

    return _this;
  }

  _createClass(ImageUpload, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          accept = _a.accept,
          clearable = _a.clearable,
          readOnly = _a.readOnly,
          className = _a.className,
          style = _a.style,
          maxSize = _a.maxSize,
          autoUpload = _a.autoUpload,
          uploadParams = _a.uploadParams,
          withCredentials = _a.withCredentials,
          dataFormat = _a.dataFormat,
          validityFailCallback = _a.validityFailCallback,
          onRemove = _a.onRemove,
          onSucess = _a.onSucess,
          onSuccess = _a.onSuccess,
          onFail = _a.onFail,
          beforeUpload = _a.beforeUpload,
          onChange = _a.onChange,
          customValidate = _a.customValidate,
          restProps = __rest(_a, ["accept", "clearable", "readOnly", "className", "style", "maxSize", "autoUpload", "uploadParams", "withCredentials", "dataFormat", "validityFailCallback", "onRemove", "onSucess", "onSuccess", "onFail", "beforeUpload", "onChange", "customValidate"]);

      var imgData = this.state.imgData;
      var clickUploadStyle = {
        display: imgData ? 'none' : 'table'
      };
      var againUploadStyle = {
        display: imgData && readOnly || !imgData ? 'none' : 'inline-block',
        left: 0
      };
      var removeImgStyle = {
        display: !clearable || imgData && readOnly || !imgData ? 'none' : 'inline-block'
      };
      var otherProps = omit(restProps, ['imgData']);
      return /*#__PURE__*/React.createElement("div", _Object$assign({}, otherProps, {
        className: classNames('roo-img-uploader', className || ''),
        style: style
      }), /*#__PURE__*/React.createElement("div", {
        className: "uploader-border",
        style: {
          display: 'none'
        }
      }), /*#__PURE__*/React.createElement("label", {
        className: "uploader-box fill"
      }, imgData && readOnly ? null : /*#__PURE__*/React.createElement("input", {
        name: "img",
        type: "file",
        accept: accept,
        className: "uploader-file-input",
        onChange: this.handleChange,
        ref: this.imageupload,
        disabled: readOnly
      }), /*#__PURE__*/React.createElement("div", {
        className: "uploader-thumbnail"
      }, /*#__PURE__*/React.createElement("img", {
        src: imgData,
        className: "uploader-thumbnail-img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "uploader-thumbnail-info",
        style: clickUploadStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-btn roo-btn-link roo-btn-block', readOnly ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-upload"
      }), /*#__PURE__*/React.createElement("span", null, locale.lng('ImageUpload.upload')))), /*#__PURE__*/React.createElement("div", {
        className: "uploader-replace-tip",
        style: againUploadStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-btn roo-btn-primary roo-btn-block roo-btn-xs"
      }, /*#__PURE__*/React.createElement("span", null, locale.lng('ImageUpload.uploadAgain'))))), /*#__PURE__*/React.createElement("div", {
        className: "uploader-loading"
      }), /*#__PURE__*/React.createElement("span", {
        className: "clear-icon",
        style: removeImgStyle,
        onClick: this.handleRemove
      }, /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-times-circle"
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;

      if (nextProps.imgData !== prevProps.imgData) {
        return {
          prevProps: nextProps,
          imgData: nextProps.imgData
        };
      }

      return null;
    }
  }]);

  return ImageUpload;
}(React.Component);

ImageUpload.defaultProps = {
  imgData: '',
  action: '',
  clearable: true,
  accept: 'image/*',
  maxSize: 2,
  readOnly: false,
  autoUpload: false,
  uploadParams: {},
  name: 'file',
  withCredentials: true,
  dataFormat: 'FileData',
  validityFailCallback: null,
  onChange: null,
  onRemove: null,
  beforeUpload: null,
  onSucess: null,
  onSuccess: null,
  onFail: null,
  customValidate: undefined
};
ImageUpload.propTypes = {
  imgData: PropTypes.string,
  action: PropTypes.string,
  clearable: PropTypes.bool,
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  readOnly: PropTypes.bool,
  dataFormat: PropTypes.string,
  autoUpload: PropTypes.bool,
  uploadParams: PropTypes.object,
  name: PropTypes.string,
  withCredentials: PropTypes.bool,
  validityFailCallback: PropTypes.func,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  beforeUpload: PropTypes.func,
  onSucess: PropTypes.func,
  onSuccess: PropTypes.func,
  onFail: PropTypes.func,
  customValidate: PropTypes.func
};
export default ImageUpload;